<script setup>
import LabelledField from "@/components/inputs/LabelledField.vue";
import {
  useFetchResourceUsingId,
  useRoute,
  useRouter,
} from "@/components/Utils/functions";

const route = useRoute();
const router = useRouter();
const roleId = route?.params?.id;

const { isLoading, data: role } = useFetchResourceUsingId("role", roleId);
</script>

<template>
  <v-container class="mt-10 mb-10">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title
            class="px-md-7 tableHeader text--text justify-space-between"
          >
            <span>{{ $t("viewRoleMsg") }}</span>
            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-btn
                  icon
                  class=""
                  :style="{ color: 'inherit' }"
                  v-on="on"
                  v-bind="attrs"
                  @click="router.back()"
                >
                  <v-icon> mdi-close </v-icon>
                </v-btn>
              </template>
              Close
            </v-tooltip>
          </v-card-title>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-skeleton-loader
                    v-if="isLoading"
                    type="button"
                    class="skeleton-fill-width"
                  />
                  <LabelledField v-else :label="$t('roleNameMsg')">
                    <v-text-field
                      class="text_field background"
                      outlined
                      dense
                      :value="role?.name"
                      readonly
                      disabled
                    />
                  </LabelledField>
                </v-col>
              </v-row>
              <v-row class="mt-8">
                <v-col cols="12" md="6">
                  <v-skeleton-loader
                    v-if="isLoading"
                    type="button"
                    class="skeleton-fill-width"
                    height="20vh"
                  />
                  <template v-else>
                    <v-card>
                      <v-card-title>
                        <div class="text-body-1">
                          {{ $t("permissionsMessage") }}
                        </div>
                      </v-card-title>
                      <v-divider />
                      <v-list
                        :style="{ maxHeight: '400px', overflow: 'scroll' }"
                      >
                        <template v-if="!!role?.permissions?.length">
                          <v-list-item
                            v-for="permission in role.permissions"
                            :key="permission.id"
                          >
                            <v-list-item-content>
                              {{ permission.name }}
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <v-list-item v-else>
                          <v-list-item-content class="secondaryText--text">
                            {{ $t("noPermissionsMsg") }}
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
